/**
 * @internal
 */
export enum ParticleRandomSubSeeds {
  Burst = 0x23571a3e,
  StartDelay = 0x13371337,
  StartColor = 0x12460f3b,
  StartSize = 0x6aed452e,
  StartRotation = 0xdec4aea1,
  randomizeRotationDirection = 0x96aa4de3,
  StartLifetime = 0x8d2c8431,
  StartSpeed = 0xf3857f6f,
  VelocityOverLifetime = 0xe0fbd834,
  ColorOverLifetime = 0x13740583,
  SizeOverLifetime = 0x591bc05c,
  RotationOverLifetime = 0x40eb95e4,
  TextureSheetAnimation = 0xbc524e5,
  Shape = 0xaf502044,
  GravityModifier = 0xa47b8c4d,
  ForceOverLifetime = 0xe6fb937c
}
